import * as React from "react";
const SvgPhoneUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeMiterlimit={10}
      d="M12.482 10.298c0 .216-.048.438-.15.654s-.234.42-.408.612a2.7 2.7 0 0 1-.984.708q-.54.227-1.17.228-.92.002-1.956-.438-1.037-.441-2.064-1.188a17 17 0 0 1-1.968-1.68 17 17 0 0 1-1.674-1.962A10.7 10.7 0 0 1 .932 5.186Q.5 4.16.5 3.224c0-.408.072-.798.216-1.158q.215-.55.69-1.002C1.79.686 2.21.5 2.654.5c.168 0 .336.036.486.108.156.072.294.18.402.336l1.392 1.962q.16.223.24.42a1 1 0 0 1 .084.366.8.8 0 0 1-.126.426 2 2 0 0 1-.336.426l-.456.474a.32.32 0 0 0-.096.24c0 .048.006.09.018.138.018.048.036.084.048.12q.162.299.558.768.403.47.87.948c.324.318.636.612.954.882.312.264.57.444.774.552q.045.02.108.048a.4.4 0 0 0 .15.024.33.33 0 0 0 .246-.102l.456-.45q.225-.227.432-.336a.8.8 0 0 1 .426-.126q.17-.002.366.078.196.081.42.234l1.986 1.41a.9.9 0 0 1 .33.384c.06.15.096.3.096.468Z"
    />
  </svg>
);
export default SvgPhoneUser;
